function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.25 3.4H4.75c-.48 0-.88.43-.88.94v.47c0 .52.4.94.88.94h10.5c.48 0 .88-.42.88-.94v-.47c0-.51-.4-.93-.88-.93zM5.04 6.69a.2.2 0 00-.1.02.22.22 0 00-.07.05.24.24 0 00-.05.19l.72 7.4c.03.34.19.66.43.89.24.23.55.35.87.35h6.32c.32 0 .63-.12.87-.35.24-.23.4-.55.43-.89l.72-7.4a.25.25 0 00-.05-.19.22.22 0 00-.08-.05.2.2 0 00-.09-.02H5.04zm6.8 5.3a.47.47 0 01.13.32.5.5 0 01-.13.34.44.44 0 01-.3.14.41.41 0 01-.32-.15L10 11.34l-1.22 1.3a.42.42 0 01-.31.14.42.42 0 01-.3-.14.49.49 0 01-.13-.33c0-.12.04-.24.12-.33l1.22-1.3-1.22-1.32a.49.49 0 01-.12-.33c0-.12.04-.24.12-.33.09-.08.2-.13.31-.13.12 0 .23.04.3.13L10 10l1.22-1.3a.42.42 0 01.61 0c.09.1.13.2.13.33s-.04.24-.12.33l-1.22 1.31 1.22 1.31z"
});

function SvgTrashX(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashX);
export default __webpack_public_path__ + "static/media/trash-x.b0d0eead.svg";
export { ForwardRef as ReactComponent };